import { useQueries } from "@tanstack/react-query";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { QUERY_KEYS } from "app/data/common/queryKeys";

export const useTerminalDetailsByNumbers = (
  terminalNumbers: string[] = []
) => {
  const queries = useQueries({
    queries: terminalNumbers.map((terminalNumber) => ({
      queryKey: [
        QUERY_KEYS.GET_TERMINAL_DETAILS_BY_NUMBER,
        terminalNumber,
      ],
      queryFn: async () => {
        const response = await apiQueryAdapter.query(
          `/terminals/${terminalNumber}`,
          "GET"
        );
        return response.data;
      },
      enabled: !!terminalNumber,
      retry: false,
      refetchOnWindowFocus: false,
    })),
  });

  const isLoading = queries.some(q => q.isLoading);

  const data = queries
    .map(q => q.data)
    .filter(Boolean);

  return {
    data,
    isLoading,
    queries, // optional: expose raw queries if needed
  };
};
